export default __webpack_public_path__ + "static/media/StandardsApps.28e03bda.png";